import { Link, useLocation } from "react-router-dom";
import intl from "react-intl-universal";
import { ShortcutCard } from "../../../Components/Atoms/ShortcutCard";
import { OPERATION_TABS } from "./constants";
import { STABLES_ACTION_ICONS } from "./stablesOperationIcons";

const OPERATION_LABEL_KEYS = {
  buy: "stables.buy",
  sell: "stables.sell",
  swap: "stables.swap",
  withdraw: "stables.withdraw",
};

const OPERATION_ROUTES = {
  buy: "/stables/comprar",
  sell: "/stables/vender",
  swap: "/stables/swap",
  withdraw: "/stables/sacar",
};

export const StablesOperationsMenu = ({
  onOpenDepositar,
  depositarActive = false,
  canOperate = true,
}) => {
  const { pathname } = useLocation();

  const shortcuts = [
    ...(canOperate
      ? [
          {
            id: "deposit",
            label: intl.get("stables.deposit"),
            icon: STABLES_ACTION_ICONS.deposit,
            onClick: onOpenDepositar,
            active: depositarActive,
          },
          ...OPERATION_TABS.map((operation) => ({
            id: operation.id,
            label: intl.get(OPERATION_LABEL_KEYS[operation.id]),
            icon: STABLES_ACTION_ICONS[operation.id],
            route: OPERATION_ROUTES[operation.id],
          })),
        ]
      : []),
    {
      id: "limits",
      label: intl.get("stables.transactionLimits"),
      icon: STABLES_ACTION_ICONS.limits,
      route: "/stables/limites",
    },
  ];

  return (
    <div className="shortcut-scroll-row">
      {shortcuts.map(({ id, label, icon: Icon, route, onClick, active }) => {
        if (onClick) {
          return (
            <ShortcutCard
              key={id}
              onClick={onClick}
              icon={Icon}
              label={label}
              active={Boolean(active)}
            />
          );
        }

        const isActive = pathname === route;

        return (
          <Link
            key={id}
            to={route}
            aria-current={isActive ? "page" : undefined}
            className={`link-no-zoom valut-shortcut-card ${isActive ? "valut-shortcut-card-active" : ""}`}
          >
            <Icon className="shortcut-icon text-brand-dark dark:text-gray-100" />
            <span className="shortcut-label">{label}</span>
          </Link>
        );
      })}
    </div>
  );
};
